import React from 'react';
import IconButton, {
  Props as IconButtonProps,
} from '../../../../../Buttons/IconButton';
import type { RequiresAccessibleLabel } from '@wix/da-a11y/pkg/typeHelpers';

interface BaseProps
  extends Omit<IconButtonProps, 'variant' | 'children' | 'type'> {}

export type Props = RequiresAccessibleLabel<BaseProps>;

const LargeInputIconButton: React.FC<Props> = props => {
  return <IconButton variant="main" type="button" {...props} />;
};

LargeInputIconButton.displayName = 'LargeInputIconButton';

export default LargeInputIconButton;
